import React, { useEffect, useState } from 'react'
import { auth } from './firebase'
import { useAuthState } from 'react-firebase-hooks/auth'
import Chat from './components/Chat'
import SignIn from './components/SignIn'

export default function App() {
  const [user] = useAuthState(auth)
  return (
    <div className="flex habijabi w-screen overflow-hidden items-center justify-center bg-gray-50 sm:h-screen">
      <div className="flex w-full habijabi sm:h-full">
        {user ? <Chat /> : <SignIn />}
      </div>
    </div>
  )
}